module.exports = __webpack_public_path__ + "assets1733911544048/img/home-img.ff28be9e.jpg";